import { Box, CircularProgress, Theme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  memorySelector,
  storySelector,
} from '@/store/selectors';
import { FC, useEffect, useRef, useState } from 'react';
import { Form } from './components';
import { setHideMediaButton, setMediaScreenType, setMediaType } from '@/store/actions';
import { UseIntermitence } from '@/hooks';
import { useRouter } from 'next/router';
import { CancelModal } from '../CancelModal';
import { setHasChanges } from '@/store/hasChanges/actions';

export const MemoriesForm: FC<any> = ({ SetMainStep }: any) => {
  const { t } = useTranslation();
  const { mediaScreenType } = useSelector(memorySelector);
  const [existData, setExistData] = useState<any>(false);
  const [isLoading, setIsLoading] = useState(true);

  const { story } = useSelector(storySelector);
  const router = useRouter();
  const dispatch = useDispatch();
  const formRef = useRef<any>(null);
  const divRef = useRef<any>(null);
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const [pendingMemory, setPendingMemory] = useState<any>(null);
  const [defaultItem, setDefaultItem] = useState<any>(null);
  const { status, switchStatus } = UseIntermitence();

  useEffect(() => {
    if (window.location !== undefined) {
      const pendMemory = JSON.parse(localStorage.getItem('pendingMemory') || 'null');
      if (pendMemory) {
        setPendingMemory(pendMemory);
        setDefaultItem(pendMemory);
        setExistData(true);
        localStorage.removeItem('pendingMemory');
      }
    }
  }, []);
  const showContainer = () => {
    switch (mediaScreenType) {
      case 'form':
      default:
        return (
          <Form
            submitForm={submitForm}
            SetMainStep={SetMainStep}
            pendingMemory={pendingMemory}
            formRef={formRef}
            setHasChanges={setHasChanges}
            divRef={divRef}
            setDefaultItem={setDefaultItem}
            changeMediaTypeScreen={changeMediaTypeScreen}
            defaultItem={defaultItem}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setExistData={setExistData}
          />
        );
    }
  };

  const changeMediaTypeScreen = () => {
    router.push(`/app/story/${story?.url}`);
    dispatch(setMediaScreenType('list'));
    dispatch(setHideMediaButton());
    setDefaultItem(null);
    dispatch(setMediaType(''));
    setExistData(false);
  };

  const submitForm = () => {
    if (formRef?.current) {
      formRef?.current?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  };

  const continueForm = () => {
    dispatch(setHasChanges(false));
    switchStatus();
  };

  return (
    <>
      <Box display={'flex'} flexDirection={'column'} width={'100%'} height={'100%'} position={'relative'}>
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={isMobile ? 'center' : 'flex-start'}
          flexDirection={isMobile ? 'column' : 'row'}
          width={'100%'}
          zIndex={0}
          height={'100%'}
          overflow={'hidden'}>
          <Box
            ref={divRef}
            borderRadius={'0.5rem'}
            width={'100%'}
            sx={{ backdropFilter: 'blur(1.5625rem)', overflowY: 'auto', overflowX: 'hidden', paddingBottom: '100px' }}
            height={'100%'}
            position={'relative'}>
            {showContainer()}
          </Box>
        </Box>
      </Box>
      <CancelModal open={status} onClose={switchStatus} confirmMethod={continueForm} />
    </>
  );
};
